module.exports = __webpack_public_path__ + "static/media/2.08b343a8.png";